export default __webpack_public_path__ + "static/media/mask.24fb2ef6.svg";